import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { ReportParams } from 'state/providers/ReportsProvider/types';
import { isUndefined } from 'lodash';
import GridColumnLayout from 'components/layout/GridColumnLayout';
import useReports from 'state/hooks/use-reports';
import ClassroomCharacterReport from '../ClassroomCharacterReport';
import ClassroomReport from '../ClassroomReport';
import StudentCharacterReport from '../StudentCharacterReport';

const getReportComponent = (params: ReportParams) => {
  if ((!!params.selectedStudentId || params.studentIds?.length === 1) && !!params.character) {
    return StudentCharacterReport;
  } else if (!isUndefined(params.character)) {
    return ClassroomCharacterReport;
  } else {
    return ClassroomReport;
  }
};

const ReportContainer: React.FC = () => {
  const classes = useStyles();
  const [{ filters }] = useReports();
  const Report = getReportComponent(filters);

  return (
    <GridColumnLayout
      containerProps={{ className: classes.container }}
      classes={{ root: classes.root }}
    >
      <Report />
    </GridColumnLayout>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1224,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(6),
    padding: `${theme.spacing(6)} ${theme.spacing(3)}`,
    flexGrow: 1,
  },
}));

export default ReportContainer;
